// extracted by mini-css-extract-plugin
export default {"manualLabResultEntryContainer":"ManualLabResultsEntry_manualLabResultEntryContainer__a0SCx"};